export const generateRandomID = length => {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const containsNumbers = str => {
  return /\d/.test(str)
}

export const validatePDFFile = file => {
  let fileErrorMsg = ''
  const supportedTypes = [
    'application/pdf',
    'application/txt',
    'application/doc'
  ]
  if (!supportedTypes.includes(file.type)) {
    fileErrorMsg = 'Only pdf,txt and doc files are supported.'
  }
  return fileErrorMsg
}

export const validateFile = file => {
  let fileErrorMsg = ''
  const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png']
  if (!supportedTypes.includes(file.type)) {
    fileErrorMsg = 'Only jpeg,jpg and png are supported.'
  }
  return fileErrorMsg
}

export const supportedImageTypes = ['image/jpeg', 'image/jpg', 'image/png']
